import React from 'react';
import { connect } from 'react-redux';
import { apiService } from '../../services';
import { withRouter } from 'react-router-dom';
import BaseSmsOpt from './BaseSmsOpt';
import { withTranslation } from 'react-i18next';
import { errorToMessage, fixID } from '../../helpers';


const PAGE_PREFIX = 'sms_opt';

class SmsOptIn extends React.Component {
  constructor(props) {
    super(props);
    const { match: { params: { blockedNumberID, type: communicationType } } } = props;
    const fixedID = fixID(blockedNumberID);
    this.params ={
      id: fixedID,
      type: 'bid',
      communicationType: communicationType || 'sms'
    }

    this.state = {parcel:null, error:null, commData:null, status:null, showBtn:true};
  }


  getCommunicationData() {
    const {
      getCommunicationDataAPI, match: { params: { parcelID } }
    } = this.props;

    const { id, type, communicationType } = this.params;
   
    if (!id) {
      this.setState({error: 'תקלה בקבלת פרטי החבילה. אנא ודאו שכתובת הדף הוכנסה במלואה.'});
      return;
    }

    const query = `communicationType=${communicationType}`;
    apiService
      .callServer(
        getCommunicationDataAPI, { ':id:': id, ':type:': type }, query, null, null, true
      )
      .then(
        _ => {
          this.setState({commData: _.data});
          this.setState({status: _.status});
          if ( _.status === 'unblocked') {
            this.setState({showBtn: false});
          }

        },
        error => {
          this.setState({error: errorToMessage(error)});
        }
      );
  }

  componentDidMount() {
    this.getCommunicationData();
  }


  getText(type) {
    const { t } = this.props;
    const { commData, status } = this.state;
    if (status === 'unblocked') {
      return t(`messageOptIn_${type}`, {commData});
    }
    return '';
  }

  unsubscribeText(type) {
    const { commData } = this.state;
    const { t } = this.props;
    return t(`cancelMsg_${type}` ,{commData});
  }

  subscribeText(type){
    const { commData } = this.state;
    const { t } = this.props;
    return t(`enableMsg_${type}`, {commData});
  }


  render() {
    const { commData, error, showBtn } = this.state;
    const type = this.params.communicationType;
    return (
      <BaseSmsOpt {...this.params} error={error} message={this.getText(type)}
        opt2={this.unsubscribeText(type)}
        opt1={this.subscribeText(type)}
        communicationData={commData}
        communicationType={type}
        showBtn={showBtn}>
      </BaseSmsOpt>
    );
  }
}
function mapStateToProps(state) {
  const { updateSmsServicesOpt, getCommunicationData } = state.api;
  return {
    updateSmsServicesOptAPI: updateSmsServicesOpt,
    getCommunicationDataAPI: getCommunicationData
  };
}
// withRouter will set the location as this.props.location
export default withTranslation(PAGE_PREFIX)(withRouter(connect(mapStateToProps)(SmsOptIn)));
